var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"bol-large-button",attrs:{"large":"","to":_vm.route}},[_c('v-layout',{attrs:{"justify-space-around":""}},[_c('v-icon',{attrs:{"color":"primary","dark":""}},[_vm._v(_vm._s(this.icon))]),_c('div',[_vm._v(_vm._s(this.label))]),_c('v-icon',[_vm._v("arrow_right_alt")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }